<template>
  <vs-button
    color="primary"
    type="border"
    class="mr-4"
    @click.prevent="backToOriginalUser"
  >
    Voltar ao Usuário Original
  </vs-button>
</template>

<script>
export default {
  methods: {
    backToOriginalUser() {
      this.$store.dispatch('user/backToOriginalUser', this.$store.state.user.userInfos)
    }
  }
}
</script>
